import React from 'react';

import type { ITextBenefit, TBenefitsDefault, TBenefitsWithTimer } from '../../models';

/**
 * Отображение подписи преимущества - основное
 * @param props пропс виджета
 * @param benefit объект преимущества
 */
export function subtitleText(props: TBenefitsDefault | TBenefitsWithTimer, benefit: ITextBenefit) {
    const { Text } = props;
    const { subtitle } = benefit;

    return (
        <Text kind="caption" styler={{ marginTop: 0, marginBottom: 0 }} view="component-secondary">
            {subtitle as string}
        </Text>
    );
}
